import React, {  useEffect, useState } from 'react' ;
import "./allusers.css" ; 
import { Tooltip } from 'react-tooltip'
import { useDispatch, useSelector } from 'react-redux';
import { getToken } from '../../RTK/Slice/Auth/AuthSlice';
import { AddUserAPI, getAllUsersAPI, getUsers, searchUserAPI } from '../../RTK/Slice/Admin/AdminSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Backdrop, Fade, Modal, Pagination, Stack } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import AllUsersList from '../../Components/AllUsers/AllUsersList';
import { confirmedPassword, notEmpty, validEmail, validPassword } from '../../Validation';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';


const AllUsersPage = () => {

  // For Handle Open Modal
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // For Access Data Modal
  const [username , setUserName ] = useState('') ;
  const [email , setEmail ] = useState('') ; 
  const [password , setPassword] = useState("" ) ;
  const [confirmPassword , setConfirmPassword] = useState("") ; 
  const [point , setPoint] = useState(0) ; 
  const [mobile , setMobile] = useState("") ;

  // For Access Search Field
  const [searchField , setSearchField] = useState('') ; 


  // For Modal Style
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    p: 4,
    };

  // For Rest All Field Value
  const restFieldValue = ()=>{
    setConfirmPassword('') ; 
    setEmail("") ; 
    setMobile("") ;
    setPassword("") ; 
    setUserName("") ; 
    setPoint(0)
  }

  // For Translate Page
  const {t} = useTranslation() ; 


  // For Access Params In Url
  const [searchParams , setSearchParams] = useSearchParams() ; 

  // For Store Pagination Value and Default Value
  const [page, setPage] = React.useState(searchParams.get("page") ? parseInt(searchParams.get("page"))  : 1 );


  // For Change Pagintion Value
  const handleChange = (event, value) => {
    if(searchParams.get('searchValue')){
      setSearchParams({page:value , searchValue : searchField})
      setPage(value);
    }

    else{
      setSearchParams({page : value}) ; 
      setPage(value);
    }
    
  };

  // For Get Token
  const token = useSelector(getToken) ; 

  // For Dispatch Action
  const dispatch = useDispatch() ;

  // For Get All Usere (call API)
  useEffect(()=>{
    if(searchParams.get('searchValue')){
      dispatch(searchUserAPI({token , searchValue : searchParams.get("searchValue")  , page}))
    }else{
      dispatch(getAllUsersAPI({token , page}))
    }
  } , [page , searchParams  , setSearchParams]) ; 

  // For Access All Users Data
  const {allUsers , statusAllUsers ,totalPages  } = useSelector(getUsers) ;

  // For Check Validation Of Add User Fields
  const valideAddUserFields = ()=>{
    if(validEmail(email)){
      if(validPassword(password)){
        if(confirmedPassword(password , confirmPassword)){
          if(notEmpty(point) && notEmpty(mobile) && notEmpty(username)  ){
            return true
          }else{
            toast.info("Please Complete Fields")
          }
        }
        else{
          toast.error("The Password and rePassword not the same")
        }
      }
      else{
        toast.error("Enter Valid Pass")
      }
    }else{
      toast.error("Enter Valid Mail")
    }
  }

  // For Add User To System
  const addUserHandler = ()=>{
    if(valideAddUserFields()){
      dispatch(AddUserAPI({token , page :page? page : 1 , username , email , password , confirmPassword , points: point , mobileNumber :mobile})) ;
      handleClose() ;  
      restFieldValue() ; 
    }

  }
  
  // For Render Add User Modal
  const renderAddUserModal = ()=>{
    return (
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
            backdrop: {
            timeout: 300,
            },
        }}
        >
        <Fade in={open}>
            <div className='k-modal my-font' style={style}>

                <div className='head'>
                    <div className='left'>
                        <h3>Add Users</h3>
                        <p>Please Make Sure When enter data</p>
                    </div>
                    <div className='right' onClick={handleClose}><FontAwesomeIcon  icon={faXmark} /></div>
                </div>
                <div className='body'>
                  <div className='row'>
                    <label htmlFor='user'>Username</label>
                    <input value={username} onChange={(e)=>setUserName(e.target.value)} className='input-row'  placeholder='Enter username' />
                  </div>
                  <div className='row'>
                    <label htmlFor='user'>Email</label>
                    <input value={email} onChange={(e)=>setEmail(e.target.value)} className='input-row' placeholder='Enter email' />
                  </div>
                  <div className='row'>
                    <label htmlFor='user'>Password</label>
                    <input value={password} onChange={(e)=>setPassword(e.target.value)} className='input-row' placeholder='Enter Password' />
                  </div>
                  <div className='row'>
                    <label htmlFor='user'>Confirmed Password</label>
                    <input value={confirmPassword} onChange={(e)=>setConfirmPassword(e.target.value)} className='input-row' placeholder='Confirmed Password' />
                  </div>
                  <div className='row'>
                    <label htmlFor='user'>Points</label>
                    <input value={point} onChange={(e)=>setPoint(e.target.value)} type="number" className='input-row' placeholder='Enter Points' />
                  </div>
                  <div className='row'>
                    <label htmlFor='user'>Mobile Number</label>
                    <input value={mobile} onChange={(e)=>setMobile(e.target.value)} type="number" className='input-row' placeholder='Enter Mobile Number' />
                  </div>
                </div>

                <div className='btn'>
                    <button onClick={addUserHandler} >Add</button>
                </div>

            </div>
            
        </Fade>
    </Modal>
    )
  }

  // For Seach for users
  const searchUserHandler = (e)=>{
    e.preventDefault() ; 
    if(searchField.length > 0) {
      dispatch(searchUserAPI({token , searchValue : searchField  , page: 1}))
      setSearchParams({page : 1 , searchValue : searchField})
    }
  }

  // For rest all users to page 1
  const restUserHandler = ()=>{
    // dispatch(getAllUsersAPI({token , page : 1}))
    setPage(1) ; 
    setSearchField("")
    setSearchParams({}) ; 
  }

  return (
    <section className='all-user-section'>

        {/* For Add User Modal */}
        {renderAddUserModal()}
        <div className='tools'>

          <form onSubmit={searchUserHandler} className='left'>
            <div className='search-bar'>
              <FontAwesomeIcon icon={faMagnifyingGlass} />
              <input onChange={(e)=>setSearchField(e.target.value)} value={searchField}  placeholder={t("searchUser")} />
            </div>
            <button type="submit" className='search-btn'>{t("search")}</button>
            <button onClick={restUserHandler} className='rest-btn'>{t("rest")}</button>
          </form>

          <div className='right'>
            <button className='add-user-btn' onClick={handleOpen}>Add User</button>
          </div>
          
        </div>

        {/* For Render ALl Users */}
        <AllUsersList allUsers={allUsers} statusAllUsers={statusAllUsers} />

        {/* For Make ToolTip */}
        <Tooltip id="my-tooltip" />

        {/* Pagination  */}
        <div className='pag-con'>
          <Stack style={{display : "flex" , justifyContent :"center"}} spacing={2}>
            <Pagination color="primary" defaultPage={searchParams.get("page") ?  parseInt(searchParams.get("page"))?parseInt(searchParams.get("page"))  : 1  : 1  } count={totalPages} page={page} onChange={handleChange} />
          </Stack>
        </div>

    </section>
  )
}

export default AllUsersPage
